import AuthService from '@/features/auth/auth-service'
import ElasticService from '@/features/elastic/elastic-service'
import { callElasticFilterForBYF } from '@/features/elastic/lib/filterb2b-utils'
import { PricesB2BParams } from '@/features/elastic/model/elastic-search'
import FlyerService from '@/features/flyer/flyer-service'
import { FlyerBuilderState } from '@/features/flyer/store/flyer-builder-state'
import HeaderMenuService from '@/features/header-menu/header-menu-service'
import MarketService from '@/features/markets/markets-service'
import { Notification } from '@/features/notification/model/notification'
import NotificationService from '@/features/notification/notification-service'
import { hashMD5 } from '@/utils/lib/utils'

export const createConfigForCurrentMarket = () => ({
	queryKey: ['market'],
	queryFn: () => MarketService.getCurrentMarket(),
})

export const createConfigForCurrentMarketLanguages = () => ({
	queryKey: ['market-languages'],
	queryFn: () => MarketService.getCurrentMarketLanguages(),
	staleTime: 90000,
})

export const createConfigForAuthSession = () => ({
	queryKey: ['auth'],
	queryFn: () => AuthService.session(),
})

export const createConfigForHeaderMenu = (options: { cache: boolean }) => ({
	queryKey: ['header-menu'],
	queryFn: () => HeaderMenuService.getHeaderMenu({ cache: options.cache }),
})

export const createConfigForPricesB2B = (params: PricesB2BParams) => ({
	queryKey: ['pricesb2b', params],
	queryFn: () => ElasticService.callPricesB2B(params),
})

export const createConfigForHSCConfig = () => ({
	queryKey: ['hsc-config'],
	queryFn: () => ElasticService.retrieveHscConfig(),
})

export const createConfigForSeasons = () => ({
	queryKey: ['seasons'],
	queryFn: () => FlyerService.retrieveSeasons(),
})

export const createElasticFilterForFlyerBuilder = (flyerBuilderState: FlyerBuilderState, itineraryIndex: number) => ({
	queryKey: ['filterb2b', 'flyerBuilder', hashMD5(flyerBuilderState)],
	queryFn: () => callElasticFilterForBYF(flyerBuilderState, itineraryIndex),
})

export type CachedNotifications = { pages: { nextCursor: number; notifications: Notification[] }[] }
export const createConfigForNotifications = (types: string[], pageSize: number) => ({
	queryKey: ['notifications'],
	queryFn: async ({ pageParam = 0 }) => {
		const response = await NotificationService.retrieve({ types, pageSize, pageNumber: pageParam })
		return { nextCursor: pageParam + 1, notifications: response }
	},
	getNextPageParam: (lastPage: { notifications: any[] }, allPages: any, lastPageParam: number) => {
		return lastPage.notifications.length === 0 ? undefined : lastPageParam + 1
	},
	initialPageParam: 0,
})
